import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { convertMarkdownToProsemirror } from '@atlassian/ai-model-io/convert-markdown-to-prosemirror';
import { CONFIG_ITEM_KEYS } from '../config-items/config-item-keys';
import { isInitialContextSelectionRange } from '../config-items/config-items';
import { getMentionMap } from '../utils/mentions/get-mention-map';
/**
 * This is responsible for processing the parsed data from
 * streamResponseParser() and passing data into the
 * AIExperienceMachine over in createAIExperienceMachine().
 */
export function streamingService(context, event) {
  function callbackHandler(_x) {
    return _callbackHandler.apply(this, arguments);
  }
  function _callbackHandler() {
    _callbackHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(callback) {
      var _configItemToUse$getI, _configItemToUse, _configItemToUse$addi, _configItemToUse2;
      var abortController, configItemToUse, mentionMap, initialContext, promptRequest, cacheKey, lastHistoryItem, streaming, additionalPromptRequest, additionalStreaming;
      return _regeneratorRuntime.wrap(function _callee3$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            abortController = new AbortController();
            /**
             * Vary prompt request triggered - if latest response exists, we are interrogating,
             * and do not want to use the original config item (i.e. may possibly be summarise/transform)
             *
             * If it is a generate with tag, the response will be captured within
             * the latest "latest response, prompt", flow.
             *
             * REVISIT THIS: analytics is based on the config item, however
             * interrogation analytics uses base generate instead to complete;
             */
            configItemToUse = context.configItem;
            if (context.baseGenerate && context.latestPromptResponse) {
              // If there is a latestPromptResponse and the context.configItem has a key 'Rovo Agent',
              // then we should use the context.configItem so we can interrogate with the Rovo Agent
              configItemToUse = context.configItem && context.configItem.key === CONFIG_ITEM_KEYS.ROVO_AGENT ? context.configItem : context.baseGenerate;
            }

            /**
             * Get mention map for the current document
             * We can no longer use the node attrs to get the mention name
             * So we now need to get all the mentions and create a mapping that can be used by the
             * markdown serializer
             */
            mentionMap = {};
            if (!context.getMentionNameDetails) {
              _context4.next = 8;
              break;
            }
            _context4.next = 7;
            return getMentionMap({
              node: context.editorView.state.doc,
              getMentionNameDetails: context.getMentionNameDetails
            });
          case 7:
            mentionMap = _context4.sent;
          case 8:
            initialContext = (_configItemToUse$getI = (_configItemToUse = configItemToUse).getInitialContext) === null || _configItemToUse$getI === void 0 ? void 0 : _configItemToUse$getI.call(_configItemToUse, {
              editorView: context.editorView,
              positions: context.positions,
              intl: context.intl,
              updateIdMap: function updateIdMap(_ref) {
                var idMap = _ref.idMap,
                  selectionType = _ref.selectionType;
                callback({
                  type: 'update idMap',
                  context: {
                    idMap: idMap,
                    selectionType: selectionType
                  }
                });
              },
              mentionMap: mentionMap
            });
            if (initialContext !== null && initialContext !== void 0 && initialContext.contentStatistics) {
              callback({
                type: 'storeContextStatistics',
                contextStatistics: {
                  inputDocument: initialContext.contentStatistics
                }
              });
            }
            if (initialContext) {
              _context4.next = 12;
              break;
            }
            throw new Error('Initial context is undefined');
          case 12:
            promptRequest = configItemToUse.triggerPromptRequest({
              analyticsContext: context.analyticsContext,
              initialContext: initialContext,
              promptInput: context.userInput,
              promptInputADF: context.userADFInput,
              latestPromptResponse: context.latestPromptResponse || undefined,
              formatMessage: context.intl.formatMessage,
              editorSchema: context.editorView.state.schema
            });
            cacheKey = JSON.stringify({
              initialContext: initialContext,
              userInput: context.userInput,
              agent: context.configItem.agent,
              //TODO: multiPrompts experiment cleanup - editor_ai_-_multi_prompts
              multiPrompt: context.multiPrompts
            }); // Right now we only ever have one object in history as we do not
            // yet support traversing the history object array. This is also to
            // prevent us saving large documents into history multiple times.
            lastHistoryItem = context.responseHistory.entries[0];
            if (!(lastHistoryItem && cacheKey === lastHistoryItem.cacheKey)) {
              _context4.next = 18;
              break;
            }
            callback({
              type: 'same cache key'
            });
            return _context4.abrupt("return");
          case 18:
            streaming = promptRequest({
              abortController: abortController,
              // Note -- when we collapse to a single "prompt request" with "api v2"
              // this would be a good opportunity to group these and pass them as a group
              generativeAIApiUrl: context.aiProvider.generativeAIApiUrl,
              product: context.aiProvider.product,
              getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
              channelId: context.channelId
            }); //TODO: multiPrompts experiment cleanup - editor_ai_-_multi_prompts
            additionalPromptRequest = (_configItemToUse$addi = (_configItemToUse2 = configItemToUse).additionalTriggerPromptRequest) === null || _configItemToUse$addi === void 0 ? void 0 : _configItemToUse$addi.call(_configItemToUse2, {
              analyticsContext: context.analyticsContext,
              initialContext: initialContext,
              promptInput: context.userInput,
              promptInputADF: context.userADFInput,
              latestPromptResponse: context.latestPromptResponse || undefined,
              formatMessage: context.intl.formatMessage,
              editorSchema: context.editorView.state.schema
            });
            additionalStreaming = additionalPromptRequest === null || additionalPromptRequest === void 0 ? void 0 : additionalPromptRequest({
              abortController: abortController,
              // Note -- when we collapse to a single "prompt request" with "api v2"
              // this would be a good opportunity to group these and pass them as a group
              generativeAIApiUrl: context.aiProvider.generativeAIApiUrl,
              product: context.aiProvider.product,
              getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
              channelId: context.channelId
            });
            if (additionalStreaming && additionalPromptRequest) {
              callback({
                type: 'handle additional prompts',
                multiPrompts: []
              });
            }
            _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _ret, _iterator, _step;
              return _regeneratorRuntime.wrap(function _callee$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _iteratorAbruptCompletion = false;
                    _didIteratorError = false;
                    _context2.prev = 2;
                    _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                      var streamItem, _streamItem$data$meta, rovoActions, markdown, _rovoActions$find, selectionType, idealSuggestion, action, _streamItem$data$meta2, _streamItem$data$meta3;
                      return _regeneratorRuntime.wrap(function _loop$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            streamItem = _step.value;
                            if (!(streamItem.state === 'loaded')) {
                              _context.next = 9;
                              break;
                            }
                            rovoActions = streamItem.data.rovoActions || [];
                            markdown = streamItem.data.content;
                            if (rovoActions.length > 0) {
                              selectionType = context.configItem.selectionType;
                              idealSuggestion = selectionType === 'range' ? 'replace' : 'insert';
                              action = (_rovoActions$find = rovoActions.find(function (x) {
                                return x.data.suggestion === idealSuggestion;
                              })) !== null && _rovoActions$find !== void 0 ? _rovoActions$find : rovoActions[0]; // There is a scenario where we are in selectionType === 'empty'
                              // but AI returns replace. In this case, we override the replace
                              // suggestion with insert.
                              if (selectionType === 'empty' && action.data.suggestion === 'replace') {
                                // This should also update the value by reference in rovoActions
                                action.data.suggestion = 'insert';
                              }
                              // The opposite can happen too
                              else if (selectionType === 'range' && action.data.suggestion === 'insert') {
                                // This should also update the value by reference in rovoActions
                                action.data.suggestion = 'replace';
                              }
                              markdown += "\n\n---\n\n".concat(action.data.content);
                            }

                            // loading done on success
                            callback({
                              type: 'complete',
                              markdown: markdown,
                              cacheKey: cacheKey,
                              modelInput: {
                                selection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : undefined
                              },
                              inputOutputDiffRatio: (_streamItem$data$meta = streamItem.data.meta) === null || _streamItem$data$meta === void 0 ? void 0 : _streamItem$data$meta.inputOutputDiffRatio,
                              rovoActions: rovoActions
                            });
                            return _context.abrupt("return", 0);
                          case 9:
                            if (!(streamItem.state === 'failed')) {
                              _context.next = 41;
                              break;
                            }
                            if (!('apiName' in streamItem && streamItem.apiName === 'assistance-service')) {
                              _context.next = 25;
                              break;
                            }
                            if (!(['RATE_LIMIT', 'OPENAI_RATE_LIMIT_USER_ABUSE'].includes(streamItem.guard) && 'retryAfter' in streamItem)) {
                              _context.next = 14;
                              break;
                            }
                            callback({
                              type: 'rate limited',
                              retryAfter: streamItem.retryAfter,
                              errorInfo: {
                                statusCode: streamItem.statusCode,
                                errorKey: streamItem.guard,
                                apiName: streamItem.apiName,
                                errorContent: 'error' in streamItem ? streamItem.error : undefined
                              }
                            });
                            return _context.abrupt("return", 0);
                          case 14:
                            if (!(streamItem.guard === 'HIPAA_CONTENT_DETECTED')) {
                              _context.next = 17;
                              break;
                            }
                            callback({
                              type: 'hipaa content fail',
                              errorInfo: {
                                statusCode: streamItem.statusCode,
                                errorKey: streamItem.guard,
                                apiName: streamItem.apiName,
                                errorContent: 'error' in streamItem ? streamItem.error : undefined
                              }
                            });
                            return _context.abrupt("return", 0);
                          case 17:
                            if (!(streamItem.guard === 'EXCEEDING_CONTEXT_LENGTH_ERROR')) {
                              _context.next = 20;
                              break;
                            }
                            callback({
                              type: 'token limit fail',
                              errorInfo: {
                                statusCode: streamItem.statusCode,
                                errorKey: streamItem.guard,
                                apiName: streamItem.apiName,
                                errorContent: 'error' in streamItem ? streamItem.error : undefined
                              }
                            });
                            return _context.abrupt("return", 0);
                          case 20:
                            if (!(streamItem.guard === 'ACCEPTABLE_USE_VIOLATIONS')) {
                              _context.next = 23;
                              break;
                            }
                            callback({
                              type: 'AUP violation detected',
                              cacheKey: cacheKey,
                              modelInput: {
                                selection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : undefined
                              },
                              errorInfo: {
                                statusCode: streamItem.statusCode,
                                errorKey: streamItem.guard,
                                apiName: streamItem.apiName,
                                errorContent: 'error' in streamItem ? streamItem.error : undefined
                              }
                            });
                            return _context.abrupt("return", 0);
                          case 23:
                            // All other errors from ConvoAI
                            callback({
                              type: 'api fail',
                              errorInfo: {
                                statusCode: streamItem.statusCode,
                                errorKey: streamItem.guard,
                                apiName: streamItem.apiName,
                                errorContent: 'error' in streamItem ? streamItem.error : undefined
                              }
                            });
                            return _context.abrupt("return", 0);
                          case 25:
                            if (!('reason' in streamItem && streamItem.reason === 'backend-input-guard')) {
                              _context.next = 32;
                              break;
                            }
                            if (!(streamItem.guard === 'INPUT_EXCEEDS_TOKEN_LIMIT')) {
                              _context.next = 29;
                              break;
                            }
                            callback({
                              type: 'token limit fail',
                              errorInfo: {
                                errorKey: streamItem.guard,
                                statusCode: streamItem.statusCode
                              }
                            });
                            return _context.abrupt("return", 0);
                          case 29:
                            if (!(streamItem.guard === 'INPUT_TOO_SHORT_TO_SUMMARIZE' || streamItem.guard === 'INPUT_TOO_SHORT_TO_PROCESS')) {
                              _context.next = 32;
                              break;
                            }
                            callback({
                              type: 'input too short fail',
                              errorInfo: {
                                errorKey: streamItem.guard,
                                statusCode: streamItem.statusCode
                              }
                            });
                            return _context.abrupt("return", 0);
                          case 32:
                            if (!('reason' in streamItem && streamItem.reason === 'rate-limited')) {
                              _context.next = 35;
                              break;
                            }
                            callback({
                              type: 'rate limited',
                              retryAfter: streamItem.retryAfter,
                              errorInfo: {
                                statusCode: streamItem.statusCode
                              }
                            });
                            return _context.abrupt("return", 0);
                          case 35:
                            if (!('reason' in streamItem && streamItem.reason === 'response-too-similar')) {
                              _context.next = 38;
                              break;
                            }
                            callback({
                              type: 'response too similar',
                              cacheKey: cacheKey,
                              modelInput: {
                                selection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : undefined
                              },
                              inputOutputDiffRatio: (_streamItem$data$meta2 = streamItem.data.meta) === null || _streamItem$data$meta2 === void 0 ? void 0 : _streamItem$data$meta2.inputOutputDiffRatio
                            });
                            return _context.abrupt("return", 0);
                          case 38:
                            callback({
                              type: 'api fail',
                              errorInfo: {
                                statusCode: streamItem.statusCode
                              }
                            });
                            _context.next = 48;
                            break;
                          case 41:
                            if (!(streamItem.state === 'aup-violation')) {
                              _context.next = 46;
                              break;
                            }
                            callback({
                              type: 'AUP violation detected',
                              cacheKey: cacheKey,
                              modelInput: {
                                selection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : undefined
                              },
                              errorInfo: {
                                statusCode: streamItem.statusCode
                              }
                            });
                            return _context.abrupt("return", 0);
                          case 46:
                            callback({
                              type: 'stream',
                              markdown: streamItem.data.content,
                              loadingStatus: (_streamItem$data$meta3 = streamItem.data.meta) === null || _streamItem$data$meta3 === void 0 ? void 0 : _streamItem$data$meta3.loadingStatus
                            });
                            return _context.abrupt("return", 0);
                          case 48:
                          case "end":
                            return _context.stop();
                        }
                      }, _loop);
                    });
                    _iterator = _asyncIterator(streaming);
                  case 5:
                    _context2.next = 7;
                    return _iterator.next();
                  case 7:
                    if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                      _context2.next = 15;
                      break;
                    }
                    return _context2.delegateYield(_loop(), "t0", 9);
                  case 9:
                    _ret = _context2.t0;
                    if (!(_ret === 0)) {
                      _context2.next = 12;
                      break;
                    }
                    return _context2.abrupt("continue", 12);
                  case 12:
                    _iteratorAbruptCompletion = false;
                    _context2.next = 5;
                    break;
                  case 15:
                    _context2.next = 21;
                    break;
                  case 17:
                    _context2.prev = 17;
                    _context2.t1 = _context2["catch"](2);
                    _didIteratorError = true;
                    _iteratorError = _context2.t1;
                  case 21:
                    _context2.prev = 21;
                    _context2.prev = 22;
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                      _context2.next = 26;
                      break;
                    }
                    _context2.next = 26;
                    return _iterator.return();
                  case 26:
                    _context2.prev = 26;
                    if (!_didIteratorError) {
                      _context2.next = 29;
                      break;
                    }
                    throw _iteratorError;
                  case 29:
                    return _context2.finish(26);
                  case 30:
                    return _context2.finish(21);
                  case 31:
                  case "end":
                    return _context2.stop();
                }
              }, _callee, null, [[2, 17, 21, 31], [22,, 26, 30]]);
            }))();

            //TODO: multiPrompts experiment cleanup - editor_ai_-_multi_prompts
            if (additionalStreaming) {
              _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var multiPrompts, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, streamItem;
                return _regeneratorRuntime.wrap(function _callee2$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      multiPrompts = [];
                      _iteratorAbruptCompletion2 = false;
                      _didIteratorError2 = false;
                      _context3.prev = 3;
                      _iterator2 = _asyncIterator(additionalStreaming);
                    case 5:
                      _context3.next = 7;
                      return _iterator2.next();
                    case 7:
                      if (!(_iteratorAbruptCompletion2 = !(_step2 = _context3.sent).done)) {
                        _context3.next = 17;
                        break;
                      }
                      streamItem = _step2.value;
                      if (!(streamItem.state === 'loaded')) {
                        _context3.next = 14;
                        break;
                      }
                      if (!streamItem.name) {
                        _context3.next = 14;
                        break;
                      }
                      multiPrompts.push({
                        name: streamItem.name,
                        content: streamItem.data.content
                      });
                      callback({
                        type: 'handle additional prompts',
                        multiPrompts: [].concat(multiPrompts)
                      });
                      return _context3.abrupt("continue", 14);
                    case 14:
                      _iteratorAbruptCompletion2 = false;
                      _context3.next = 5;
                      break;
                    case 17:
                      _context3.next = 23;
                      break;
                    case 19:
                      _context3.prev = 19;
                      _context3.t0 = _context3["catch"](3);
                      _didIteratorError2 = true;
                      _iteratorError2 = _context3.t0;
                    case 23:
                      _context3.prev = 23;
                      _context3.prev = 24;
                      if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                        _context3.next = 28;
                        break;
                      }
                      _context3.next = 28;
                      return _iterator2.return();
                    case 28:
                      _context3.prev = 28;
                      if (!_didIteratorError2) {
                        _context3.next = 31;
                        break;
                      }
                      throw _iteratorError2;
                    case 31:
                      return _context3.finish(28);
                    case 32:
                      return _context3.finish(23);
                    case 33:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee2, null, [[3, 19, 23, 33], [24,, 28, 32]]);
              }))();
            }

            // Cleanup function
            return _context4.abrupt("return", function () {
              abortController.abort();
            });
          case 25:
          case "end":
            return _context4.stop();
        }
      }, _callee3);
    }));
    return _callbackHandler.apply(this, arguments);
  }
  return callbackHandler;
}

//TODO: AI Button experiment cleanup - platform_editor_ai_ai_button_block_elements
export function streamingServiceAIButton(context, event) {
  function callbackHandler(_x2) {
    return _callbackHandler2.apply(this, arguments);
  }
  function _callbackHandler2() {
    _callbackHandler2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(callback) {
      var abortController, configItemToUse, mentionMap, triggeredFor, positions, editorView, idMap, state, schema, doc, nodeTypeName, layoutSection, emptyLayout, newLayoutColumns, triggerRequestCalls, currentRequestCallIndex, isComplete, panel, emptyPanel, _startPos, _endPos, _streamContentProcessor, expand, emptyExpand, _startPos2, _endPos2, _streamContentProcessor2, triggerRequest, _triggerRequest;
      return _regeneratorRuntime.wrap(function _callee8$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _triggerRequest = function _triggerRequest3() {
              _triggerRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(positions, streamContentProcessor, isComplete) {
                var _configItemToUse$getI2, _configItemToUse3;
                var initialContext, promptRequest, cacheKey, lastHistoryItem, streaming, _configItemToUse$addi2, _configItemToUse4, additionalPromptRequest, additionalStreaming;
                return _regeneratorRuntime.wrap(function _callee7$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      initialContext = (_configItemToUse$getI2 = (_configItemToUse3 = configItemToUse).getInitialContext) === null || _configItemToUse$getI2 === void 0 ? void 0 : _configItemToUse$getI2.call(_configItemToUse3, {
                        editorView: context.editorView,
                        positions: positions,
                        intl: context.intl,
                        updateIdMap: function updateIdMap(_ref5) {
                          var idMap = _ref5.idMap,
                            selectionType = _ref5.selectionType;
                          callback({
                            type: 'update idMap',
                            context: {
                              idMap: idMap,
                              selectionType: selectionType
                            }
                          });
                        },
                        mentionMap: mentionMap
                      });
                      if (initialContext !== null && initialContext !== void 0 && initialContext.contentStatistics) {
                        callback({
                          type: 'storeContextStatistics',
                          contextStatistics: {
                            inputDocument: initialContext.contentStatistics
                          }
                        });
                      }
                      if (initialContext) {
                        _context9.next = 4;
                        break;
                      }
                      throw new Error('Initial context is undefined');
                    case 4:
                      promptRequest = configItemToUse.triggerPromptRequest({
                        initialContext: initialContext,
                        promptInput: context.userInput,
                        promptInputADF: context.userADFInput,
                        latestPromptResponse: context.latestPromptResponse || undefined,
                        formatMessage: context.intl.formatMessage,
                        editorSchema: context.editorView.state.schema
                      });
                      cacheKey = JSON.stringify({
                        initialContext: initialContext,
                        userInput: context.userInput,
                        agent: context.configItem.agent
                      }); // Right now we only ever have one object in history as we do not
                      // yet support traversing the history object array. This is also to
                      // prevent us saving large documents into history multip[le times.
                      lastHistoryItem = context.responseHistory.entries[0];
                      if (!(lastHistoryItem && cacheKey === lastHistoryItem.cacheKey)) {
                        _context9.next = 10;
                        break;
                      }
                      callback({
                        type: 'same cache key'
                      });
                      return _context9.abrupt("return");
                    case 10:
                      streaming = promptRequest({
                        abortController: abortController,
                        // Note -- when we collapse to a single "prompt request" with "api v2"
                        // this would be a good opportunity to group these and pass them as a group
                        generativeAIApiUrl: context.aiProvider.generativeAIApiUrl,
                        product: context.aiProvider.product,
                        getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
                        channelId: context.channelId
                      });
                      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                        var _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _loop2, _ret2, _iterator3, _step3;
                        return _regeneratorRuntime.wrap(function _callee5$(_context7) {
                          while (1) switch (_context7.prev = _context7.next) {
                            case 0:
                              _iteratorAbruptCompletion3 = false;
                              _didIteratorError3 = false;
                              _context7.prev = 2;
                              _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2() {
                                var streamItem, rovoActions, markdown, processedResponse, _rovoActions$find2, selectionType, idealSuggestion, action, isCompleted, _streamItem$data$meta4, _streamItem$data$meta5, _streamItem$data$meta6, _streamItem$data$meta7, _streamItem$data$meta8;
                                return _regeneratorRuntime.wrap(function _loop2$(_context6) {
                                  while (1) switch (_context6.prev = _context6.next) {
                                    case 0:
                                      streamItem = _step3.value;
                                      if (!(streamItem.state === 'loaded')) {
                                        _context6.next = 10;
                                        break;
                                      }
                                      rovoActions = streamItem.data.rovoActions || [];
                                      markdown = streamItem.data.content;
                                      processedResponse = {
                                        markdown: markdown
                                      };
                                      if (rovoActions.length > 0) {
                                        selectionType = context.configItem.selectionType;
                                        idealSuggestion = selectionType === 'range' ? 'replace' : 'insert';
                                        action = (_rovoActions$find2 = rovoActions.find(function (x) {
                                          return x.data.suggestion === idealSuggestion;
                                        })) !== null && _rovoActions$find2 !== void 0 ? _rovoActions$find2 : rovoActions[0]; // There is a scenario where we are in selectionType === 'empty'
                                        // but AI returns replace. In this case, we override the replace
                                        // suggestion with insert.
                                        if (selectionType === 'empty' && action.data.suggestion === 'replace') {
                                          // This should also update the value by reference in rovoActions
                                          action.data.suggestion = 'insert';
                                        }
                                        // The opposite can happen too
                                        else if (selectionType === 'range' && action.data.suggestion === 'insert') {
                                          // This should also update the value by reference in rovoActions
                                          action.data.suggestion = 'replace';
                                        }
                                        markdown += "\n\n---\n\n".concat(action.data.content);
                                      } else {
                                        processedResponse = streamContentProcessor(streamItem.data.content);
                                      }

                                      // loading done on success
                                      if (isComplete) {
                                        isCompleted = isComplete();
                                        if (isCompleted) {
                                          callback(_objectSpread(_objectSpread({
                                            type: 'complete'
                                          }, processedResponse), {}, {
                                            cacheKey: cacheKey,
                                            modelInput: {
                                              selection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : undefined
                                            },
                                            inputOutputDiffRatio: (_streamItem$data$meta4 = streamItem.data.meta) === null || _streamItem$data$meta4 === void 0 ? void 0 : _streamItem$data$meta4.inputOutputDiffRatio,
                                            rovoActions: rovoActions
                                          }));
                                        } else {
                                          callback(_objectSpread(_objectSpread({
                                            type: 'stream'
                                          }, processedResponse), {}, {
                                            loadingStatus: (_streamItem$data$meta5 = streamItem.data.meta) === null || _streamItem$data$meta5 === void 0 ? void 0 : _streamItem$data$meta5.loadingStatus
                                          }));
                                        }
                                      } else {
                                        callback(_objectSpread(_objectSpread({
                                          type: 'complete'
                                        }, processedResponse), {}, {
                                          cacheKey: cacheKey,
                                          modelInput: {
                                            selection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : undefined
                                          },
                                          inputOutputDiffRatio: (_streamItem$data$meta6 = streamItem.data.meta) === null || _streamItem$data$meta6 === void 0 ? void 0 : _streamItem$data$meta6.inputOutputDiffRatio,
                                          rovoActions: rovoActions
                                        }));
                                      }
                                      return _context6.abrupt("return", 0);
                                    case 10:
                                      if (!(streamItem.state === 'failed')) {
                                        _context6.next = 42;
                                        break;
                                      }
                                      if (!('apiName' in streamItem && streamItem.apiName === 'assistance-service')) {
                                        _context6.next = 26;
                                        break;
                                      }
                                      if (!(['RATE_LIMIT', 'OPENAI_RATE_LIMIT_USER_ABUSE'].includes(streamItem.guard) && 'retryAfter' in streamItem)) {
                                        _context6.next = 15;
                                        break;
                                      }
                                      callback({
                                        type: 'rate limited',
                                        retryAfter: streamItem.retryAfter,
                                        errorInfo: {
                                          statusCode: streamItem.statusCode,
                                          errorKey: streamItem.guard,
                                          apiName: streamItem.apiName,
                                          errorContent: 'error' in streamItem ? streamItem.error : undefined
                                        }
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 15:
                                      if (!(streamItem.guard === 'HIPAA_CONTENT_DETECTED')) {
                                        _context6.next = 18;
                                        break;
                                      }
                                      callback({
                                        type: 'hipaa content fail',
                                        errorInfo: {
                                          statusCode: streamItem.statusCode,
                                          errorKey: streamItem.guard,
                                          apiName: streamItem.apiName,
                                          errorContent: 'error' in streamItem ? streamItem.error : undefined
                                        }
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 18:
                                      if (!(streamItem.guard === 'EXCEEDING_CONTEXT_LENGTH_ERROR')) {
                                        _context6.next = 21;
                                        break;
                                      }
                                      callback({
                                        type: 'token limit fail',
                                        errorInfo: {
                                          statusCode: streamItem.statusCode,
                                          errorKey: streamItem.guard,
                                          apiName: streamItem.apiName,
                                          errorContent: 'error' in streamItem ? streamItem.error : undefined
                                        }
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 21:
                                      if (!(streamItem.guard === 'ACCEPTABLE_USE_VIOLATIONS')) {
                                        _context6.next = 24;
                                        break;
                                      }
                                      callback({
                                        type: 'AUP violation detected',
                                        cacheKey: cacheKey,
                                        modelInput: {
                                          selection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : undefined
                                        },
                                        errorInfo: {
                                          statusCode: streamItem.statusCode,
                                          errorKey: streamItem.guard,
                                          apiName: streamItem.apiName,
                                          errorContent: 'error' in streamItem ? streamItem.error : undefined
                                        }
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 24:
                                      // All other errors from ConvoAI
                                      callback({
                                        type: 'api fail',
                                        errorInfo: {
                                          statusCode: streamItem.statusCode,
                                          errorKey: streamItem.guard,
                                          apiName: streamItem.apiName,
                                          errorContent: 'error' in streamItem ? streamItem.error : undefined
                                        }
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 26:
                                      if (!('reason' in streamItem && streamItem.reason === 'backend-input-guard')) {
                                        _context6.next = 33;
                                        break;
                                      }
                                      if (!(streamItem.guard === 'INPUT_EXCEEDS_TOKEN_LIMIT')) {
                                        _context6.next = 30;
                                        break;
                                      }
                                      callback({
                                        type: 'token limit fail',
                                        errorInfo: {
                                          errorKey: streamItem.guard,
                                          statusCode: streamItem.statusCode
                                        }
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 30:
                                      if (!(streamItem.guard === 'INPUT_TOO_SHORT_TO_SUMMARIZE' || streamItem.guard === 'INPUT_TOO_SHORT_TO_PROCESS')) {
                                        _context6.next = 33;
                                        break;
                                      }
                                      callback({
                                        type: 'input too short fail',
                                        errorInfo: {
                                          errorKey: streamItem.guard,
                                          statusCode: streamItem.statusCode
                                        }
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 33:
                                      if (!('reason' in streamItem && streamItem.reason === 'rate-limited')) {
                                        _context6.next = 36;
                                        break;
                                      }
                                      callback({
                                        type: 'rate limited',
                                        retryAfter: streamItem.retryAfter,
                                        errorInfo: {
                                          statusCode: streamItem.statusCode
                                        }
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 36:
                                      if (!('reason' in streamItem && streamItem.reason === 'response-too-similar')) {
                                        _context6.next = 39;
                                        break;
                                      }
                                      callback({
                                        type: 'response too similar',
                                        cacheKey: cacheKey,
                                        modelInput: {
                                          selection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : undefined
                                        },
                                        inputOutputDiffRatio: (_streamItem$data$meta7 = streamItem.data.meta) === null || _streamItem$data$meta7 === void 0 ? void 0 : _streamItem$data$meta7.inputOutputDiffRatio
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 39:
                                      callback({
                                        type: 'api fail',
                                        errorInfo: {
                                          statusCode: streamItem.statusCode
                                        }
                                      });
                                      _context6.next = 49;
                                      break;
                                    case 42:
                                      if (!(streamItem.state === 'aup-violation')) {
                                        _context6.next = 47;
                                        break;
                                      }
                                      callback({
                                        type: 'AUP violation detected',
                                        cacheKey: cacheKey,
                                        modelInput: {
                                          selection: isInitialContextSelectionRange(initialContext) ? initialContext.selection : undefined
                                        },
                                        errorInfo: {
                                          statusCode: streamItem.statusCode
                                        }
                                      });
                                      return _context6.abrupt("return", 0);
                                    case 47:
                                      callback(_objectSpread({
                                        type: 'stream',
                                        loadingStatus: (_streamItem$data$meta8 = streamItem.data.meta) === null || _streamItem$data$meta8 === void 0 ? void 0 : _streamItem$data$meta8.loadingStatus
                                      }, streamContentProcessor(streamItem.data.content)));
                                      return _context6.abrupt("return", 0);
                                    case 49:
                                    case "end":
                                      return _context6.stop();
                                  }
                                }, _loop2);
                              });
                              _iterator3 = _asyncIterator(streaming);
                            case 5:
                              _context7.next = 7;
                              return _iterator3.next();
                            case 7:
                              if (!(_iteratorAbruptCompletion3 = !(_step3 = _context7.sent).done)) {
                                _context7.next = 15;
                                break;
                              }
                              return _context7.delegateYield(_loop2(), "t0", 9);
                            case 9:
                              _ret2 = _context7.t0;
                              if (!(_ret2 === 0)) {
                                _context7.next = 12;
                                break;
                              }
                              return _context7.abrupt("continue", 12);
                            case 12:
                              _iteratorAbruptCompletion3 = false;
                              _context7.next = 5;
                              break;
                            case 15:
                              _context7.next = 21;
                              break;
                            case 17:
                              _context7.prev = 17;
                              _context7.t1 = _context7["catch"](2);
                              _didIteratorError3 = true;
                              _iteratorError3 = _context7.t1;
                            case 21:
                              _context7.prev = 21;
                              _context7.prev = 22;
                              if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                                _context7.next = 26;
                                break;
                              }
                              _context7.next = 26;
                              return _iterator3.return();
                            case 26:
                              _context7.prev = 26;
                              if (!_didIteratorError3) {
                                _context7.next = 29;
                                break;
                              }
                              throw _iteratorError3;
                            case 29:
                              return _context7.finish(26);
                            case 30:
                              return _context7.finish(21);
                            case 31:
                            case "end":
                              return _context7.stop();
                          }
                        }, _callee5, null, [[2, 17, 21, 31], [22,, 26, 30]]);
                      }))();
                      if (!(triggeredFor !== null && triggeredFor !== void 0 && triggeredFor.isBlock)) {
                        //TODO: multiPrompts experiment cleanup - editor_ai_-_multi_prompts
                        additionalPromptRequest = (_configItemToUse$addi2 = (_configItemToUse4 = configItemToUse).additionalTriggerPromptRequest) === null || _configItemToUse$addi2 === void 0 ? void 0 : _configItemToUse$addi2.call(_configItemToUse4, {
                          analyticsContext: context.analyticsContext,
                          initialContext: initialContext,
                          promptInput: context.userInput,
                          promptInputADF: context.userADFInput,
                          latestPromptResponse: context.latestPromptResponse || undefined,
                          formatMessage: context.intl.formatMessage,
                          editorSchema: context.editorView.state.schema
                        });
                        additionalStreaming = additionalPromptRequest === null || additionalPromptRequest === void 0 ? void 0 : additionalPromptRequest({
                          abortController: abortController,
                          // Note -- when we collapse to a single "prompt request" with "api v2"
                          // this would be a good opportunity to group these and pass them as a group
                          generativeAIApiUrl: context.aiProvider.generativeAIApiUrl,
                          product: context.aiProvider.product,
                          getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
                          channelId: context.channelId
                        });
                        if (additionalStreaming && additionalPromptRequest) {
                          callback({
                            type: 'handle additional prompts',
                            multiPrompts: []
                          });
                        }

                        //TODO: multiPrompts experiment cleanup - editor_ai_-_multi_prompts
                        if (additionalStreaming) {
                          _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                            var multiPrompts, _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, streamItem;
                            return _regeneratorRuntime.wrap(function _callee6$(_context8) {
                              while (1) switch (_context8.prev = _context8.next) {
                                case 0:
                                  multiPrompts = [];
                                  _iteratorAbruptCompletion4 = false;
                                  _didIteratorError4 = false;
                                  _context8.prev = 3;
                                  _iterator4 = _asyncIterator(additionalStreaming);
                                case 5:
                                  _context8.next = 7;
                                  return _iterator4.next();
                                case 7:
                                  if (!(_iteratorAbruptCompletion4 = !(_step4 = _context8.sent).done)) {
                                    _context8.next = 17;
                                    break;
                                  }
                                  streamItem = _step4.value;
                                  if (!(streamItem.state === 'loaded')) {
                                    _context8.next = 14;
                                    break;
                                  }
                                  if (!streamItem.name) {
                                    _context8.next = 14;
                                    break;
                                  }
                                  multiPrompts.push({
                                    name: streamItem.name,
                                    content: streamItem.data.content
                                  });
                                  callback({
                                    type: 'handle additional prompts',
                                    multiPrompts: [].concat(multiPrompts)
                                  });
                                  return _context8.abrupt("continue", 14);
                                case 14:
                                  _iteratorAbruptCompletion4 = false;
                                  _context8.next = 5;
                                  break;
                                case 17:
                                  _context8.next = 23;
                                  break;
                                case 19:
                                  _context8.prev = 19;
                                  _context8.t0 = _context8["catch"](3);
                                  _didIteratorError4 = true;
                                  _iteratorError4 = _context8.t0;
                                case 23:
                                  _context8.prev = 23;
                                  _context8.prev = 24;
                                  if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
                                    _context8.next = 28;
                                    break;
                                  }
                                  _context8.next = 28;
                                  return _iterator4.return();
                                case 28:
                                  _context8.prev = 28;
                                  if (!_didIteratorError4) {
                                    _context8.next = 31;
                                    break;
                                  }
                                  throw _iteratorError4;
                                case 31:
                                  return _context8.finish(28);
                                case 32:
                                  return _context8.finish(23);
                                case 33:
                                case "end":
                                  return _context8.stop();
                              }
                            }, _callee6, null, [[3, 19, 23, 33], [24,, 28, 32]]);
                          }))();
                        }
                      }
                    case 13:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee7);
              }));
              return _triggerRequest.apply(this, arguments);
            };
            triggerRequest = function _triggerRequest2(_x6, _x7, _x8) {
              return _triggerRequest.apply(this, arguments);
            };
            abortController = new AbortController();
            /**
             * Vary prompt request triggered - if latest response exists, we are interrogating,
             * and do not want to use the original config item (i.e. may possibly be summarise/transform)
             *
             * If it is a generate with tag, the response will be captured within
             * the latest "latest response, prompt", flow.
             *
             * REVISIT THIS: analytics is based on the config item, however
             * interrogation analytics uses base generate instead to complete;
             */
            configItemToUse = context.configItem;
            if (context.baseGenerate && context.latestPromptResponse) {
              // If there is a latestPromptResponse and the context.configItem has a key 'Rovo Agent',
              // then we should use the context.configItem so we can interrogate with the Rovo Agent
              configItemToUse = context.configItem && context.configItem.key === CONFIG_ITEM_KEYS.ROVO_AGENT ? context.configItem : context.baseGenerate;
            }

            /**
             * Get mention map for the current document
             * We can no longer use the node attrs to get the mention name
             * So we now need to get all the mentions and create a mapping that can be used by the
             * markdown serializer
             */
            mentionMap = {};
            if (!context.getMentionNameDetails) {
              _context10.next = 10;
              break;
            }
            _context10.next = 9;
            return getMentionMap({
              node: context.editorView.state.doc,
              getMentionNameDetails: context.getMentionNameDetails
            });
          case 9:
            mentionMap = _context10.sent;
          case 10:
            triggeredFor = context.triggeredFor, positions = context.positions, editorView = context.editorView, idMap = context.idMap;
            state = editorView.state;
            schema = state.schema, doc = state.doc;
            if (triggeredFor !== null && triggeredFor !== void 0 && triggeredFor.isBlock) {
              nodeTypeName = triggeredFor.name; // Summarise, Make shorter and Suggest a title does not need to preserve structure
              //	and will not be replacing block elements.
              if ([CONFIG_ITEM_KEYS.SUMMARISE_WRITING, CONFIG_ITEM_KEYS.MAKE_SHORTER, CONFIG_ITEM_KEYS.SUGGEST_A_TITLE, CONFIG_ITEM_KEYS.FIND_ACTION_ITEMS].includes(configItemToUse.key)) {
                triggerRequest(positions, function (streamContent) {
                  return {
                    markdown: streamContent
                  };
                });
              } else if (nodeTypeName === 'layoutSection') {
                layoutSection = doc.nodeAt(positions[0]);
                if (layoutSection) {
                  emptyLayout = layoutSection.copy();
                  newLayoutColumns = [];
                  triggerRequestCalls = [];
                  currentRequestCallIndex = 0;
                  isComplete = function isComplete() {
                    var nextCallRequest = triggerRequestCalls[currentRequestCallIndex + 1];
                    if (nextCallRequest) {
                      currentRequestCallIndex = currentRequestCallIndex + 1;
                      nextCallRequest();
                    }
                    return !nextCallRequest;
                  };
                  layoutSection.forEach( /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(node, offset, index) {
                      var startPos, endPos, streamContentProcessor, triggerCellRequest;
                      return _regeneratorRuntime.wrap(function _callee4$(_context5) {
                        while (1) switch (_context5.prev = _context5.next) {
                          case 0:
                            streamContentProcessor = function _streamContentProcess(streamContent) {
                              var _convertMarkdownToPro = convertMarkdownToProsemirror({
                                  schema: schema,
                                  markdown: streamContent,
                                  idMap: idMap,
                                  featureToggles: {
                                    markdownPlus: true,
                                    markdownPlusExtensions: true,
                                    markdownPlusPanels: true,
                                    markdownPlusDecisions: true
                                  }
                                }),
                                pmFragment = _convertMarkdownToPro.pmFragment;
                              newLayoutColumns[index] = node.copy(pmFragment);
                              var newLayout = emptyLayout.copy(Fragment.from(newLayoutColumns));
                              return {
                                markdown: streamContent,
                                fragment: Fragment.from(newLayout)
                              };
                            };
                            startPos = positions[0] + offset;
                            endPos = startPos + node.nodeSize;
                            triggerCellRequest = function triggerCellRequest() {
                              triggerRequest([startPos, endPos], streamContentProcessor, isComplete);
                            };
                            triggerRequestCalls.push(triggerCellRequest);
                          case 5:
                          case "end":
                            return _context5.stop();
                        }
                      }, _callee4);
                    }));
                    return function (_x3, _x4, _x5) {
                      return _ref4.apply(this, arguments);
                    };
                  }());
                  triggerRequestCalls[0]();
                }
              } else if (nodeTypeName === 'panel') {
                panel = doc.nodeAt(positions[0]);
                if (panel) {
                  emptyPanel = panel.copy();
                  _startPos = positions[0] + 1;
                  _endPos = positions[1] - 1;
                  _streamContentProcessor = function _streamContentProcessor(streamContent) {
                    var _convertMarkdownToPro2 = convertMarkdownToProsemirror({
                        schema: schema,
                        markdown: streamContent,
                        idMap: idMap,
                        featureToggles: {
                          markdownPlus: true,
                          markdownPlusExtensions: true,
                          markdownPlusPanels: true,
                          markdownPlusDecisions: true
                        }
                      }),
                      pmFragment = _convertMarkdownToPro2.pmFragment;
                    var newPanel = emptyPanel.copy(pmFragment);
                    return {
                      markdown: streamContent,
                      fragment: Fragment.from(newPanel)
                    };
                  };
                  triggerRequest([_startPos, _endPos], _streamContentProcessor);
                }
              } else if (nodeTypeName === 'table' || nodeTypeName === 'tableCell' || nodeTypeName === 'tableHeader') {
                triggerRequest(positions, function (streamContent) {
                  return {
                    markdown: streamContent
                  };
                });
              } else if (nodeTypeName === 'expand' || nodeTypeName === 'nestedExpand') {
                expand = doc.nodeAt(positions[0]);
                if (expand) {
                  emptyExpand = expand.copy();
                  _startPos2 = positions[0] + 1;
                  _endPos2 = positions[1] - 1;
                  _streamContentProcessor2 = function _streamContentProcessor2(streamContent) {
                    var _convertMarkdownToPro3 = convertMarkdownToProsemirror({
                        schema: schema,
                        markdown: streamContent,
                        idMap: idMap,
                        featureToggles: {
                          markdownPlus: true,
                          markdownPlusExtensions: true,
                          markdownPlusPanels: true,
                          markdownPlusDecisions: true
                        }
                      }),
                      pmFragment = _convertMarkdownToPro3.pmFragment;
                    var newExpand = emptyExpand.copy(pmFragment);
                    return {
                      markdown: streamContent,
                      fragment: Fragment.from(newExpand)
                    };
                  };
                  triggerRequest([_startPos2, _endPos2], _streamContentProcessor2);
                }
              } else {
                triggerRequest(positions, function (streamContent) {
                  return {
                    markdown: streamContent
                  };
                });
              }
            } else {
              triggerRequest(positions, function (streamContent) {
                return {
                  markdown: streamContent
                };
              });
            }

            // Cleanup function
            return _context10.abrupt("return", function () {
              abortController.abort();
            });
          case 15:
          case "end":
            return _context10.stop();
        }
      }, _callee8);
    }));
    return _callbackHandler2.apply(this, arguments);
  }
  return callbackHandler;
}